<template>
    <section class="tofas-trust" dir="rtl" aria-labelledby="tofas-trust-title">
        <div class="tofas-trust__container">
            <div class="tofas-trust__hero-card">
                <div class="tofas-trust__content">
                    <div class="tofas-trust__topline">
                        <span class="tofas-trust__badge">كورسـات متقدمة بعد أولى ثانوي</span>
                        <div class="tofas-trust__logos" aria-label="Sprix و TOFAS">
                            <span class="tofas-trust__logo-pill">
                                <img src="/img/sprix-logo.png" alt="شعار Sprix" />
                            </span>
                            <span class="tofas-trust__logo-pill">
                                <img src="/img/tofas-logo.png" alt="شعار TOFAS" />
                            </span>
                        </div>
                    </div>

                    <h2 id="tofas-trust-title" class="tofas-trust__title">
                        غنيم هو اللي بيعمل الكورسات المتقدمة لطلاب أولى ثانوي على TOFAS
                    </h2>

                    <div class="tofas-trust__description">
                        <p>
                            محمد غنيم مش بس بيشرح Programming &amp; AI من خلال البرمجة مع غنيم،
                            لكنه كمان بيعمل وبيقدّم الكورسات المتقدمة الموجودة على TOFAS
                            لطلاب أولى ثانوي من خلال Sprix.
                        </p>
                        <p>
                            وده معناه إن الطالب مش بيتعلم المنهج وبس، لكن كمان يقدر يبدأ ياخد
                            خطوة أكبر في طريق البرمجة، ويفهم مهارات عملية حقيقية تساعده بعد كده.
                        </p>
                    </div>

                    <div class="tofas-trust__proof">
                        <lucide-icon name="CheckCircle2" class="tofas-trust__proof-icon" />
                        <span>الكورسات المتقدمة اللي بتظهر على TOFAS معمولة ومقدّمة بواسطة غنيم من خلال Sprix.</span>
                    </div>

                    <div class="tofas-trust__path" aria-label="رحلة الطالب من أولى ثانوي إلى كورسات TOFAS">
                        <span>أساس أولى ثانوي</span>
                        <lucide-icon name="ArrowLeft" class="tofas-trust__path-icon" />
                        <span>Programming &amp; AI</span>
                        <lucide-icon name="ArrowLeft" class="tofas-trust__path-icon" />
                        <span>كورسات TOFAS المتقدمة</span>
                    </div>

                    <div class="tofas-trust__actions">
                        <router-link :to="{ name: 'register' }" class="tofas-trust__btn tofas-trust__btn--primary">
                            سجّل مع البرمجة مع غنيم
                            <lucide-icon name="ArrowLeft" class="tofas-trust__btn-icon" />
                        </router-link>
                        <a
                            class="tofas-trust__btn tofas-trust__btn--secondary"
                            href="https://egy.learning.programming-sc.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            شوف الكورسات المتقدمة على TOFAS
                        </a>
                    </div>
                </div>

                <div class="tofas-trust__visual">
                    <div class="tofas-trust__portrait">
                        <div class="tofas-trust__portrait-frame" aria-hidden="true" />
                        <div class="tofas-trust__portrait-dots" aria-hidden="true" />
                        <div class="tofas-trust__portrait-glow" aria-hidden="true" />
                        <div class="tofas-trust__portrait-glow tofas-trust__portrait-glow--cyan" aria-hidden="true" />
                        <div class="tofas-trust__portrait-media">
                            <img
                                :src="portraitImage"
                                alt="محمد غنيم يقدم كورسات Programming & AI والكورسات المتقدمة على TOFAS"
                                width="1024"
                                height="1024"
                                class="tofas-trust__portrait-image"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                        <span class="tofas-trust__floating-badge">الكورسات المتقدمة على TOFAS</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import LucideIcon from './LucideIcon.vue';

export default {
    name: 'WelcomeTofasTrust',
    components: { LucideIcon },
    data() {
        return {
            portraitImage: require('@/assets/welcome/ghonaim-ecosystem.webp'),
        };
    },
};
</script>
